(function($){
  'use strict';

  if(!$.gnv){
      $.gnv = new Object();
  };
})(jQuery);
